import React from 'react';
import styles from '../Poison/Poison.module.css';

const cardPattiBack = "/assets/img/cards/patti_back.png"; // Default back

const JokerVisual = ({ data, poisonCard, playerA, playerB }) => {
    // Data format: "7SS,7HH,1,1,1,1,1"
    // First card is Joker, then Player A (3 cards), then Player B (3 cards)
    
    const cardString = data || "";
    const cardTokens = cardString.split(",").map(t => t.trim());
    
    const getCardImage = (token) => {
        if (!token || token === "1" || token === "0") return cardPattiBack; 
        return `/assets/img/cards/${token}.png`;
    };

    // Joker Logic:
    // Joker: Index 0
    // Player A: Indices 1, 2, 3
    // Player B: Indices 4, 5, 6
    
    const jokerCardImage = poisonCard || (cardTokens[0] && cardTokens[0] !== "1" && cardTokens[0] !== "0" 
        ? getCardImage(cardTokens[0])
        : null);

    const playerACards = playerA?.cards || [1, 2, 3].map(i => {
        const token = cardTokens[i];
        return getCardImage(token);
    });

    const playerBCards = playerB?.cards || [4, 5, 6].map(i => {
        const token = cardTokens[i];
        return getCardImage(token);
    });

    return (
        <div className={styles.poisonContainer}>
            {/* Joker Card */}
            {jokerCardImage && (
                <div className={styles.poisonSection}>
                    <span className={styles.poisonName}>JOKER</span>
                    <div className={styles.poisonCard}>
                        <img 
                            src={jokerCardImage} 
                            alt="Joker Card"
                            className={styles.cardImage}
                            onError={(e) => {
                                e.target.style.display = 'none';
                            }}
                        />
                    </div>
                </div>
            )}
            
            {/* Player A */}
            <div className={styles.playerSection}>
                <span className={styles.playerName}>Player A</span>
                <div className={styles.playerCards}>
                    {playerACards.map((card, index) => (
                        <img 
                            key={`${index}-${card}`} 
                            src={card} 
                            alt={`Player A card ${index + 1}`}
                            className={styles.cardImage}
                            onError={(e) => {
                                e.target.style.display = 'none';
                            }}
                        />
                    ))}
                </div>
            </div>
            
            {/* Player B */}
            <div className={styles.playerSection}>
                <span className={styles.playerName}>Player B</span>
                <div className={styles.playerCards}>
                    {playerBCards.map((card, index) => (
                        <img 
                            key={`${index}-${card}`} 
                            src={card} 
                            alt={`Player B card ${index + 1}`}
                            className={styles.cardImage}
                            onError={(e) => {
                                e.target.style.display = 'none';
                            }}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default JokerVisual;
